import moment from 'moment-timezone'

export function isRegistrationClosed(registrationPeriodEnd, timeZone = 'UTC') {
  const tz = timeZone || 'UTC'
  const now = moment.tz(tz)
  const d = moment.utc(registrationPeriodEnd)

  const endTimeOnEventTimeZone = moment
    .tz({ year: d.year(), month: d.month(), day: d.date() }, tz)
    .endOf('day')

  return now.isAfter(endTimeOnEventTimeZone)
}

export function isRegistrationChangeByAthletePeriodEnded(periodEnd, timeZone = 'UTC') {
  const tz = timeZone || 'UTC'
  const now = moment.tz(tz)
  const d = moment.utc(periodEnd)

  const endTimeOnEventTimeZone = moment
    .tz({ year: d.year(), month: d.month(), day: d.date() }, tz)
    .endOf('day')

  return now.isAfter(endTimeOnEventTimeZone)
}
